export abstract class InteractComponent {

    /**
     * From http://interactjs.io/#resizing
     * @param event
     */
    protected resizeEvent(event): void {

        event.stopPropagation();
        const target = event.target;
        let x = (parseFloat(target.getAttribute('data-x')) || 0);
        let y = (parseFloat(target.getAttribute('data-y')) || 0);

        const minSize = { width: 120, height: 120 };

        const rectWidth = Math.max(minSize.width, event.rect.width);
        const rectHeight = Math.max(minSize.height, event.rect.height);

        // update the element's style
        target.style.width = `${rectWidth}px`;
        target.style.height = `${rectHeight}px`;

        // translate when resizing from top or left edges
        x += event.deltaRect.left;
        y += event.deltaRect.top;

        target.style.webkitTransform = target.style.transform =
            `translate(${x}px,${y}px)`;

        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
    }

    /**
     * From http://interactjs.io/#resizing
     * @param event
     */
    protected dragEvent(event): void {
        event.stopPropagation();
        const target = event.target;
        // keep the dragged position in the data-x/data-y attributes
        const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
        const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

        // translate the element
        target.style.webkitTransform =
            target.style.transform =
                `translate(${x}px, ${y}px)`;

        // update the posiion attributes
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
    }
}
